import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDelete, doDownload, doPostFiles } from './utils'

//const API_ROOT2 = 'http://localhost/api'

//make contract
export const getMakeContract = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/make-contract`
  return doGet(url)
}

export const updateMakeContract = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/make-contract`
  return doPut(url, request)
}

//change withdraw person
export const getMakeContractChangeWithdrawPerson = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/make-contract/change-withdraw-person`
  return doGet(url)
}

export const updateMakeContractChangeWithdrawPerson = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/make-contract/change-withdraw-person`
  return doPut(url, request)
}

export const deleteAttachmentChangeWithdrawPerson = (projectVersionId, fileId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/make-contract/change-withdraw-person/attachments/${fileId}`
  return doDelete(url)
}

//not make contract
export const getNotMakeContract = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/not-make-contract`
  return doGet(url)
}

export const updateNotMakeContract = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/not-make-contract`
  return doPut(url, request)
}

//ขอทำข้อตกลงเพิ่มเติม
export const getChangeAgreement = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/change-agreement`
  return doGet(url)
}

//บันทึก ข้อตกลงเพิ่มเติมตาม Master Subject
export const saveChangeAgreement = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/change-agreement`
  return doPost(url, request)
}

//ส่งขอทำข้อตกลงเพิ่มเติม
export const updateChangeAgreement = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/change-agreement`
  return doPut(url, request)
}

//ขั้นที่ 1 ตรวจสอบคุณสมบัติผู้รับทุน
export const getContractGranteeInfo = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/grantee`
  return doGet(url)
}

//ขั้นที่ 2 ตรวจสอบสัญญาและไฟล์แนบ
export const getContractAttachment = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/check-attachments`
  return doGet(url)
}

//นักวิชาการ ตรวจสอบไฟล์
export const updateCheckAttachments = (projectVersionId, fileId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/check-attachments/${fileId}`
  return doPut(url)
}

export const updateRequestDocument = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/request-document`
  return doPut(url, request)
}

export const updateUncertified = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/uncertified`
  return doPut(url, request)
}

//get หน้า ไม่ผ่านคุณสมบัติ uncertifiled
export const getUncertified = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/uncertified`
  return doGet(url)
}

//ขั้นที่ 3 เสนอผู้มีอำนาจลงนาม
export const getSignContract = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/sign-contract`
  return doGet(url)
}

export const updateSignContract = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/sign-contract`
  return doPut(url, request)
}

//ขั้นที่ 4 การลงนามในสัญญา
export const getContractor = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/contractor`
  return doGet(url)
}

//มีคำร้องขอแก้ไขสัญญา/ข้อตกลง หลังลงนาม 1 (ดำเนินการ)
export const getSendEditContract = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/modify-contract`
  return doGet(url)
}

export const updateSendEditContract = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/modify-contract`
  return doPut(url, request)
}

export const getEditContractRevise = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/modify-contract/feedback`
  return doGet(url)
}

export const updateSendEditContractSecureApprove = (request, projectVersionId) => {
  // const API_ROOT = 'http://localhost:9004/api'
  const url = `${API_ROOT}/contract/${projectVersionId}/modify-contract/secure-approve`
  return doPut(url, request)
}

export const responseEditContractSecureApprove = (referenceId) => {
  // const API_ROOT = 'http://localhost:9004/api'
  const url = `${API_ROOT}/contract/${referenceId}/modify-contract/secure-approve`
  return doGet(url)
}

//อนุมัติสัญญาหลายโครงการ
// export const modifyContractSecureApproveMulti = (request, approveStatus) => {
//   const url = `${API_ROOT}/contract/multiple/modify-contract/secure-approve?approveStatus=${approveStatus}`
//   return doPost(url, request)
// }

//เอกสาร คุณสัมบัติผู้รับทุนหรือเกี่ยวกับสัญญา
export const saveAttachmentGrantee = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/attachments`
  return doPost(url, request)
}

export const saveAttachmentModifyContract = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/modify-contract/attachments`
  return doPost(url, request)
}

export const deleteAttachmentGrantee = (projectVersionId, fileId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/attachments/${fileId}`
  return doDelete(url)
}

export const getDownloadAttachmentGrantee = (projectVersionId, fileId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/attachments/${fileId}/download`
  return doDownload(url)
}

//เอกสารสัญญา PDF
export const getContractPdf = (projectVersionId) => {
  const url = `${API_ROOT}/files/${projectVersionId}/contract/form`
  return doDownload(url)
}

export const getDownloadContractPdf = (projectVersionId, filename) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/${filename}/download`
  return doDownload(url)
}

export const getDownloadContractPdfRealtime = (projectVersionId) => {
  const url = `${API_ROOT}/files/${projectVersionId}/contract/form`
  return doDownload(url)
}

export const getDownloadProposalPdfRealtime = (projectVersionId) => {
  const url = `${API_ROOT}/files/${projectVersionId}/proposal/form`
  return doDownload(url)
}

export const getBankAccount = (projectVersionId, bankCode = null) => {
  // const API_ROOT = 'http://localhost:80/api'
  let url = ''
  if (!bankCode) {
    url = `${API_ROOT}/contract/${projectVersionId}/bank-account`
  } else {
    url = `${API_ROOT}/contract/${projectVersionId}/bank-account?bankCode=${bankCode}`
  }
  // const url = `${API_ROOT}/contract/${projectVersionId}/bank-account`
  return doGet(url)
}

export const saveBankAccount = (request, projectVersionId) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/contract/${projectVersionId}/bank-account`
  return doPost(url, request)
}

export const getCreateProjectVender = (projectVersionId) => {
  // const API_ROOT = 'http://localhost:80/api'
  // http://localhost/api/contract/3C750E0C-E547-47DD-97B8-E3ABB10A9473/vender/create
  const url = `${API_ROOT}/contract/${projectVersionId}/vender/create`
  return doGet(url)
}

export const getRefreshProjectVender = (projectVersionId) => {
  // const API_ROOT = 'http://localhost:80/api'
  //http://localhost/api/contract/3C750E0C-E547-47DD-97B8-E3ABB10A9473/vender/refresh
  const url = `${API_ROOT}/contract/${projectVersionId}/vender/refresh`
  return doGet(url)
}

export const getUpdateProjectVender = (projectVersionId) => {
  // const API_ROOT = 'http://localhost:80/api'
  //http://localhost/api/contract/123/vender/update
  const url = `${API_ROOT}/contract/${projectVersionId}/vender/update`
  return doGet(url)
}

export const getOpenBankAccount = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/open-bank-account`
  return doGet(url)
}

export const saveOpenBankAccount = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/open-bank-account`
  return doPost(url, request)
}

export const downloadOpenBankAccountFile = (projectVersionId) => {
  const url = `${API_ROOT}/files/${projectVersionId}/account/letter`
  return doDownload(url)
}

export const getContractSubmitForm = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/contract-result`
  return doGet(url)
}

export const saveContractSubmit = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/contract-result`
  return doPost(url)
}

export const getContractorsStatus = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/contractors/status`
  return doGet(url)
}

export const getBookbankStatus = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/bookbank/status`
  return doGet(url)
}

export const getAddAttachmentsContractForm = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/add-attachments`
  return doGet(url)
}

export const saveAddAttachmentsContract = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/add-attachments`
  return doPost(url)
}

export const saveAddAttachmentsContractAndBankAccount = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/add-attachments/bank-account`
  return doPost(url, request)
}

// เจ้าหน้าที่ศูนย์สัญญา บันทุกขอทำสัญญา
export const contractRequest = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/contract-request`
  return doPost(url, request)
}

//ตรวจสอบเอกสารประกอบการทำสัญญา
export const getSendFileToESignPage = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/resend-file/page`
  return doGet(url)
}

export const updateSendFileToESign = (projectVersionId, request) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/resend-file/send`
  return doPost(url, request)
}

// ---------------------------------- subproject
export const getContractSubProject = (projectVersionId) => {
  // /api/subproject/{projectVersionId}/contract
  const url = `${API_ROOT}/subproject/${projectVersionId}/contract`
  return doGet(url)
}

//เอกสารสัญญา PDF
export const getContractPdfSubProject = (projectVersionId) => {
  // /api/report/download/{projectVersionId}/contractform
  const url = `${API_ROOT}/files/download/${projectVersionId}/contractform`
  // /api/subproject/{projectVersionId}/contract/file/download
  // const url = `${API_ROOT}/subproject/${projectVersionId}/contract/download`
  return doDownload(url)
}

export const saveWitnessName = (request, projectVersionId) => {
  // /api/subproject/{projectVersionId}/contract
  const url = `${API_ROOT}/subproject/${projectVersionId}/contract`
  return doPost(url, request)
}

export const uploadDocumentsContract = (projectVersionId, request) => {
  // /api/subproject/{projectVersionId}/contract/file
  const url = `${API_ROOT}/subproject/${projectVersionId}/contract/file`
  return doPost(url, request)
}

export const getDownloadAttachContractPdf = (projectVersionId, pathName) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/contract/file/download?path=${pathName}`
  return doDownload(url)
}
// ----------------------------------

//บันทึกแก้ไขเพิ่มเติมข้อตกลง
export const getContractChangeFormPage = (projectVersionId, contractChangeId) => {
  // const API_ROOT = 'http://localhost:9004/api'
  const url = `${API_ROOT}/contract/${projectVersionId}/contract-change/from?id=${
    contractChangeId || ''
  }`
  return doGet(url)
}

export const saveContractChangeForm = (projectVersionId, request) => {
  // const API_ROOT = 'http://localhost:9004/api'
  const url = `${API_ROOT}/contract/${projectVersionId}/contract-change/from`
  return doPostFiles(url, request)
}

export const saveAttachmentPapertype = (request, projectid, id) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/contract/${projectid}/contract-change/attachment-papertype/${id}`
  return doPostFiles(url, request)
}

export const sendContractChangeSign = (projectVersionId, contractChangeId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/contract-change/sign/${contractChangeId}`
  return doPut(url)
}

export const getContractChangeFile = (projectVersionId, contractChangeId) => {
  const url = `${API_ROOT}/files/${projectVersionId}/contract-change/form/${contractChangeId}`
  return doDownload(url)
}

export const getEContractFile = (filePath) => {
  const url = `${API_ROOT}/contract/econtract/attachments/download?url=${filePath}`
  return doDownload(url)
}

export const getContractChangeHistory = (projectVersionId) => {
  // const API_ROOT = 'http://localhost:9004/api'
  const url = `${API_ROOT}/contract/${projectVersionId}/contract-change/from/history`
  return doGet(url)
}

// ---------------------------------- subproject new
export const getContractSubProjectNew = (projectVersionId, projectCode) => {
  const url = `${API_ROOT}/subproject/contract-new?projectVersionId=${
    projectVersionId || ''
  }&projectCode=${projectCode || ''}`
  return doGet(url)
}

export const saveContractSubProjectNew = (projectVersionId, request, projectCode) => {
  const url = `${API_ROOT}/subproject/contract-new?projectVersionId=${
    projectVersionId || ''
  }&projectCode=${projectCode || ''}`
  return doPost(url, request)
}

export const uploadDocumentsContractNew = (projectVersionId, request, projectCode) => {
  // /api/subproject/{projectVersionId}/contract/file
  const url = `${API_ROOT}/subproject/contract-new/file?projectVersionId=${
    projectVersionId || ''
  }&projectCode=${projectCode || ''}`
  return doPost(url, request)
}

export const getDownloadAttachContractPdfNew = (projectVersionId, pathName) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/contract-new/file/download?path=${pathName}`
  return doDownload(url)
}

export const cancelContract = (projectVersionId, request = {}, projectCode) => {
  // /api/subproject/{projectVersionId}/contract/file
  const url = `${API_ROOT}/subproject/contract-new/cancel?projectVersionId=${
    projectVersionId || ''
  }&projectCode=${projectCode || ''}`
  return doPost(url, request)
}

export const sendESignContractSubproject = (request, projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/subproject/send-esignature`
  return doPut(url, request)
}

export const getDownloadContractPdfNew = (projectVersionId) => {
  const url = `${API_ROOT}/files/subproject/contract/${projectVersionId}`
  return doDownload(url)
}

export const generateContractPdfNew = (projectVersionId) => {
  const url = `${API_ROOT}/files/subproject/generate/contract/${projectVersionId}`
  return doGet(url)
}

export const downloadFileByPath = (pathFile) => {
  const url = `${API_ROOT}/v1/accounting/download/file?filePath=${pathFile}`
  return doDownload(url)
}

//ประวัติขอแก้ไขสัญญา
export const contractChangeHistoy = (projectVersionId) => {
  // const API_ROOT = 'http://localhost:9004/api'
  const url = `${API_ROOT}/contract/contract-change/history/${projectVersionId}`
  return doGet(url)
}

export const getStampedDocument = (projectVersionId) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/contract/${projectVersionId}/stamped-document`
  return doGet(url)
}

export const getStampedDocumentUrl = (projectVersionId) => {
  // http://localhost/api/contract/222/attachments/stamped-document
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/contract/${projectVersionId}/attachments/stamped-document`
  return url
}

export const saveStampedDocument = (projectVersionId, request) => {
  // http://localhost/api/contract/222/attachments/stamped-document
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/contract/${projectVersionId}/attachments/stamped-document`
  return doPostFiles(url, request)
}
